import React, { useEffect, useMemo, useState } from 'react';

const PARTNER_ICONS = {
    explorandes: { domain: 'explorandes.com' },
    'amazonas-explorer': { domain: 'amazonas-explorer.com' },
    'rainforest-expeditions-sac': { domain: 'rainforestexpeditions.com' },
    'andean-lodges': { domain: 'andeanlodges.com' },
    'camino-del-apu-ausangate-scrl': { domain: 'andeanlodges.com' },
    'condor-travel': { domain: 'condortravel.com' },
    'condor-travel-sa': { domain: 'condortravel.com' },
    'condor-travel-s-a-c': { domain: 'condortravel.com' },
    'domiruth-travel-service-s-a-c-46': { domain: 'domiruthperutravel.com' },
    trexperience: { domain: 'trexperienceperu.com' },
    trexperienceperu: { domain: 'trexperienceperu.com' },
    'peru-for-less': { domain: 'peruforless.com' },
    'action-peru-treks': { domain: 'actionperutreks.com' },
    'action-peru-treks-21': { domain: 'actionperutreks.com' },
    'crees-manu-s-a-c': { domain: 'crees-manu.org' },
    'magri-tour-operator-ltda': { domain: 'magritouroperator.com' },
    'sa-luxury-expeditions-llc': { domain: 'saexpeditions.com' },
    'expertia-travel-s-a': { domain: 'expertiatravel.com' },
    'nature-services-peru': { domain: 'regenera.earth' },
    'responsible-travel-peru': { domain: 'responsibletravel.com' },
    'tropic-travel': { domain: 'tropiceco.com' },
    'qhapac-nan-travel-sac': { domain: 'www.qnperu.com' },
    'qn-travel-peru': { domain: 'www.qnperu.com' },
    'candor-joyer-a': { domain: 'www.candor.pe' },
    'rivers-forest-expeditions': { domain: 'rfexpeditions.com' },
    'albergue-ollantaytambo-e-i-r-l': { domain: 'https://elalbergue.com' },
    'caritas-abancay': { domain: 'caritasabancay.org' },
    // 'asociaci-n-servicios-ecosist-micos-per-seperu': { domain: '' },    // SEPERU association
    'hotelera-del-valle-s-a-c': { domain: 'antiguacusco.com' },
    'hotelera-del-valle-sac': { domain: 'antiguacusco.com' },
    'trigono-capital': { domain: 'trigonocapital.com' },
    'doble-e-inversiones-s-a-c': { domain: 'www.ee-co.com' },
    // 'sociedad-inmobiliaria-los-algarrobos-sa': { domain: '' },          // real estate — likely no usable favicon
    'strategik-sac': { domain: 'sacstrategic.com' },
    'elementa-srl': { domain: 'elementa.srl' },
    // 'independiente':                  individual — always logo fallback
};

const FAVICON_PX = 128;
const ICON_MIN_PX = 26;
const ICON_MAX_PX = 46;
const ICON_DEFAULT_PX = 36; // shown before the natural size is known

const getPartnerFaviconUrl = (slug, website) => {
    const entry = (slug && PARTNER_ICONS[slug]) || (website ? { domain: website } : null);
    if (!entry) return null;
    if (entry.iconUrl) return entry.iconUrl;
    if (!entry.domain) return null;
    const domain = entry.domain.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(
        domain
    )}&sz=${FAVICON_PX}`;
};

const overlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(7, 28, 19, 0.48)',
    backdropFilter: 'blur(6px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '24px',
};

const modalStyle = {
    width: '100%',
    maxWidth: '560px',
    background: '#F7F7F3',
    borderRadius: '28px',
    boxShadow: '0 30px 80px rgba(9, 36, 24, 0.20)',
    overflow: 'hidden',
    border: '1px solid rgba(9, 80, 52, 0.08)',
};

const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 24px 16px 24px',
};

const titleStyle = {
    margin: 0,
    fontSize: '28px',
    lineHeight: '34px',
    color: '#05412D',
    fontWeight: 600,
};

const closeButtonStyle = {
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    border: '1px solid rgba(5, 65, 45, 0.12)',
    background: '#FFFFFF',
    color: '#05412D',
    fontSize: '20px',
    cursor: 'pointer',
};

const bodyStyle = {
    padding: '0 24px 24px 24px',
};

const introStyle = {
    color: '#406156',
    fontSize: '16px',
    lineHeight: '26px',
    margin: '0 0 20px 0',
};

const cardStyle = {
    background: '#FFFFFF',
    borderRadius: '22px',
    padding: '18px',
    border: '1px solid rgba(5, 65, 45, 0.08)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '20px',
};

const logoWrapStyle = {
    width: '64px',
    height: '64px',
    minWidth: '64px',
    borderRadius: '50%',
    background: '#FFFFFF',
    border: '1px solid rgba(127, 164, 106, 0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    flexShrink: 0,
};

// Logo fallback uses `contain` (NOT `cover`) so wide wordmark logos like
// Explorandes letterbox cleanly instead of being cropped / squished.
const logoFallbackStyle = {
    width: '82%',
    height: '82%',
    objectFit: 'contain',
    display: 'block',
};

const cardTextTitleStyle = {
    margin: 0,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#05412D',
    fontWeight: 600,
    wordBreak: 'break-word',
};

const cardTextSubStyle = {
    margin: '4px 0 0 0',
    fontSize: '14px',
    lineHeight: '22px',
    color: '#6B7F75',
};

const labelStyle = {
    display: 'block',
    fontSize: '13px',
    lineHeight: '18px',
    color: '#6B7F75',
    marginBottom: '8px',
};

const urlRowStyle = {
    display: 'flex',
    gap: '10px',
    marginBottom: '18px',
};

const inputStyle = {
    flex: 1,
    height: '52px',
    borderRadius: '16px',
    border: '1px solid rgba(5, 65, 45, 0.12)',
    background: '#FFFFFF',
    padding: '0 16px',
    fontSize: '14px',
    color: '#05412D',
    outline: 'none',
};

const primaryButtonBaseStyle = {
    height: '52px',
    minWidth: '130px',
    padding: '0 18px',
    borderRadius: '16px',
    border: 'none',
    color: '#FFFFFF',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 220ms ease',
    transform: 'translateY(0) scale(1)',
    boxShadow: '0 10px 22px rgba(111, 167, 69, 0.18)',
};

const secondaryButtonStyle = {
    flex: 1,
    height: '52px',
    borderRadius: '16px',
    border: '1px solid rgba(5, 65, 45, 0.12)',
    background: '#FFFFFF',
    color: '#05412D',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
};

const buttonRowStyle = {
    display: 'flex',
    gap: '12px',
};

const successTextStyle = {
    marginTop: '12px',
    fontSize: '13px',
    color: '#4C8D57',
    opacity: 1,
    transition: 'opacity 180ms ease',
};

const copiedBadgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
};

const checkDotStyle = {
    width: '18px',
    height: '18px',
    minWidth: '18px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.22)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    lineHeight: 1,
};

const SharePageModal = ({
    isOpen,
    onClose,
    partnerName,
    shareUrl,
    partnerSlug, // NEW: listing slug, used to resolve the favicon
    partnerWebsite, // OPTIONAL: org website/domain if you store one (overrides the map)
    partnerLogo, // fallback when no favicon resolves or it fails to load
}) => {
    const [copied, setCopied] = useState(false);

    // Favicon state
    const [iconNaturalSize, setIconNaturalSize] = useState(null);
    const [iconFailed, setIconFailed] = useState(false);

    const faviconUrl = useMemo(() => getPartnerFaviconUrl(partnerSlug, partnerWebsite), [
        partnerSlug,
        partnerWebsite,
    ]);

    useEffect(() => {
        if (!isOpen) return;

        const handleEsc = event => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEsc);
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (!copied) return;

        const timer = setTimeout(() => {
            setCopied(false);
        }, 2200);

        return () => clearTimeout(timer);
    }, [copied]);

    // Reset favicon load state whenever the source or open state changes.
    useEffect(() => {
        setIconNaturalSize(null);
        setIconFailed(false);
    }, [faviconUrl, isOpen]);

    const shareMessage = useMemo(() => {
        return `Check out the public profile of ${partnerName} on Regenera.`;
    }, [partnerName]);

    if (!isOpen) return null;

    const handleCopy = async () => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(shareUrl);
            } else {
                const textArea = document.createElement('textarea');
                textArea.value = shareUrl;
                textArea.style.position = 'fixed';
                textArea.style.left = '-9999px';
                textArea.style.top = '-9999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }

            setCopied(true);
        } catch (error) {
            console.error('Failed to copy share url:', error);
        }
    };

    const handleNativeShare = async () => {
        try {
            if (navigator.share) {
                await navigator.share({
                    title: `${partnerName} on Regenera`,
                    text: shareMessage,
                    url: shareUrl,
                });
            } else {
                await handleCopy();
            }
        } catch (error) {
            console.error('Share action cancelled or failed:', error);
        }
    };

    const handleIconLoad = e => {
        const natural = Math.max(e.target.naturalWidth || 0, e.target.naturalHeight || 0);
        setIconNaturalSize(natural);
    };

    // Adapt the favicon size to its natural resolution, clamped to the circle.
    const renderedIconSize = iconNaturalSize
        ? Math.min(Math.max(iconNaturalSize, ICON_MIN_PX), ICON_MAX_PX)
        : ICON_DEFAULT_PX;

    const showFavicon = Boolean(faviconUrl) && !iconFailed;

    const faviconImgStyle = {
        width: `${renderedIconSize}px`,
        height: `${renderedIconSize}px`,
        objectFit: 'contain',
        display: 'block',
        opacity: iconNaturalSize ? 1 : 0, // fade in once measured, avoids size flash
        transition: 'opacity 160ms ease',
    };

    const primaryButtonStyle = {
        ...primaryButtonBaseStyle,
        background: copied ? '#4C8D57' : '#6FA745',
        transform: copied ? 'translateY(-1px) scale(1.02)' : 'translateY(0) scale(1)',
        boxShadow: copied
            ? '0 14px 26px rgba(76, 141, 87, 0.24)'
            : '0 10px 22px rgba(111, 167, 69, 0.18)',
    };
    return (
        <div style={overlayStyle} onClick={onClose}>
            <div style={modalStyle} onClick={e => e.stopPropagation()}>
                <div style={headerStyle}>
                    <h2 style={titleStyle}>Share this page</h2>
                    <button type="button" style={closeButtonStyle} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div style={bodyStyle}>
                    <p style={introStyle}>
                        Help more people discover the work {partnerName} is supporting. Share this
                        page beautifully and directly from here.
                    </p>

                    <div style={cardStyle}>
                        <div style={logoWrapStyle}>
                            {showFavicon ? (
                                <img
                                    src={faviconUrl}
                                    alt={partnerName}
                                    onLoad={handleIconLoad}
                                    onError={() => setIconFailed(true)}
                                    style={faviconImgStyle}
                                />
                            ) : (
                                <img
                                    src={partnerLogo}
                                    alt={partnerName}
                                    style={logoFallbackStyle}
                                />
                            )}
                        </div>

                        <div style={{ minWidth: 0 }}>
                            <p style={cardTextTitleStyle}>{partnerName}</p>
                            <p style={cardTextSubStyle}>Public profile ready to share</p>
                        </div>
                    </div>

                    <label style={labelStyle}>Share link</label>

                    <div style={urlRowStyle}>
                        <input type="text" readOnly value={shareUrl} style={inputStyle} />
                        <button type="button" style={primaryButtonStyle} onClick={handleCopy}>
                            {copied ? (
                                <span style={copiedBadgeStyle}>
                                    <span style={checkDotStyle}>✓</span>
                                    Copied!
                                </span>
                            ) : (
                                'Copy link'
                            )}
                        </button>
                    </div>

                    <div style={buttonRowStyle}>
                        <button
                            type="button"
                            style={secondaryButtonStyle}
                            onClick={handleNativeShare}
                        >
                            Share now
                        </button>

                        <button
                            type="button"
                            style={secondaryButtonStyle}
                            onClick={() =>
                                window.open(
                                    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                                        shareUrl
                                    )}`,
                                    '_blank',
                                    'noopener,noreferrer'
                                )
                            }
                        >
                            LinkedIn
                        </button>
                    </div>

                    {copied ? <div style={successTextStyle}>Link copied to clipboard.</div> : null}
                </div>
            </div>
        </div>
    );
};

export default SharePageModal;
